import pino from 'pino'

// Map pino levels to Google Cloud logging severity strings
const levelToSeverity: Record<string, string> = {
  trace: 'DEBUG',
  debug: 'DEBUG',
  info: 'INFO',
  warn: 'WARNING',
  error: 'ERROR',
  fatal: 'CRITICAL',
}

// Create pino logger instance configured for Google Cloud logging
export const logger = pino({
  formatters: {
    level(label) {
      return {
        level: label,
        severity: levelToSeverity[label] || 'DEFAULT',
      }
    },
    // Copy err.stack to top-level stack_trace for Cloud Error Reporting
    log(object) {
      const { err } = object as { err?: { stack?: string } }
      if (err?.stack) {
        return { ...object, stack_trace: err.stack }
      }
      return object
    },
  },
  messageKey: 'message',
})
